import { useEffect } from 'react';
import PropTypes from 'prop-types';

const BypassIfComplete = (props: any) => {
  const bypassRender = props.isComplete && !props.neverBypass;

  useEffect(() => {
    if (bypassRender) {
      props.onBypass();
    }
  }, []);

  if (bypassRender) {
    return null;
  }

  return props.children;
};
BypassIfComplete.propTypes = {
  onBypass: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  isComplete: PropTypes.bool.isRequired,
  neverBypass: PropTypes.bool
};
BypassIfComplete.defaultProps = {
  neverBypass: false
};
export default BypassIfComplete;
